import { DocumentType } from '../types';

export function isInfoGathering(documentType: DocumentType): boolean {
  return (documentType.type === 'info_gathering');
}
